import { Link } from "react-router-dom";
import { PrivacyFooter } from "@/components/privacy/PrivacyFooter";
import { AnalyticsPreferences } from "@/components/privacy/AnalyticsPreferences";

export default function CookieSettings() {
  return <>
    <main className="mx-auto min-h-[75vh] max-w-3xl px-6 pb-20 pt-20" data-testid="cookie-settings-page">
      <Link to="/" className="text-sm underline underline-offset-4" data-testid="cookie-settings-home">Return to Vitura</Link>
      <h1 className="mt-12 font-display text-4xl sm:text-5xl" data-testid="cookie-settings-title">Cookie settings</h1>
      <p className="mt-6 text-sm leading-relaxed" data-testid="cookie-settings-essential">Essential storage supports site operation and remembers your privacy choice. Optional analytics uses limited page views, not session replay or form contents.</p>
      <AnalyticsPreferences />
    </main>
    <PrivacyFooter prefix="cookie-settings" />
  </>;
}